/**
 * Offline Wrapper Component
 * Wraps the app with offline banner and conflict resolution dialog
 */

import React from 'react';
import { useOffline } from '../context/OfflineContext';
import OfflineBanner from './OfflineBanner';
import ConflictResolutionDialog from './ConflictResolutionDialog';

const OfflineWrapper = ({ children }) => {
  const {
    isOnline,
    isServerReachable,
    isOffline,
    isSyncing,
    syncProgress,
    pendingCount,
    lastSyncTime,
    conflicts,
    hasConflicts,
    showConflictDialog,
    setShowConflictDialog,
    triggerSync,
    updateConflicts
  } = useOffline();

  return (
    <>
      {/* Offline Banner - shows at top of page */}
      <OfflineBanner
        isOffline={isOffline}
        isOnline={isOnline}
        isServerReachable={isServerReachable}
        pendingCount={pendingCount}
        isSyncing={isSyncing}
        syncProgress={syncProgress}
        lastSyncTime={lastSyncTime}
        hasConflicts={hasConflicts}
        onSync={triggerSync}
        onShowConflicts={() => setShowConflictDialog(true)}
      />

      {/* Main content - add padding when banner is shown */}
      <div className={pendingCount > 0 || isOffline || hasConflicts || isSyncing ? 'pt-12' : ''}>
        {children}
      </div>

      {/* Conflict Resolution Dialog */}
      <ConflictResolutionDialog
        open={showConflictDialog}
        onOpenChange={setShowConflictDialog}
        conflicts={conflicts}
        onResolved={updateConflicts}
      />
    </>
  );
};

export default OfflineWrapper;
